(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  const getCollectionCarouselState = (carousel) => {
    if (!carousel) return null;

    const slider = carousel.querySelector('[id^="Slider-"]');
    const slides = Array.from(carousel.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);

    if (!slider || !slides.length) return null;

    const itemOffset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;

    if (itemOffset <= 0) return null;

    const slidesPerPage = Math.max(1, Math.floor((slider.clientWidth - slides[0].offsetLeft) / itemOffset));
    const maxStartIndex = Math.max(0, slides.length - slidesPerPage);
    const totalPages = Math.max(1, Math.ceil(slides.length / slidesPerPage));
    const pageStarts = Array.from({ length: totalPages }).map((_, index) =>
      Math.min(index * slidesPerPage, maxStartIndex)
    );
    const currentStartIndex = Math.round(slider.scrollLeft / itemOffset);
    const currentPage =
      pageStarts.reduce((closestPage, startIndex, index) => {
        const currentDistance = Math.abs(currentStartIndex - startIndex);
        const closestDistance = Math.abs(currentStartIndex - pageStarts[closestPage]);

        return currentDistance < closestDistance ? index : closestPage;
      }, 0) + 1;

    return {
      slider,
      slides,
      itemOffset,
      slidesPerPage,
      maxStartIndex,
      totalPages,
      pageStarts,
      currentPage,
    };
  };

  const updateCollectionCarouselDots = (carousel) => {
    const state = getCollectionCarouselState(carousel);
    const dotsContainer = carousel.querySelector('[data-collection-carousel-dots]');

    if (!state || !dotsContainer) return;

    if (dotsContainer.children.length !== state.totalPages) {
      dotsContainer.replaceChildren();

      Array.from({ length: state.totalPages }).forEach((_, index) => {
        const dot = document.createElement('button');
        const dotIndicator = document.createElement('span');

        dot.type = 'button';
        dot.className = 'slider-counter__link slider-counter__link--dots link';
        dot.dataset.collectionCarouselPageDot = index;
        dot.setAttribute('aria-controls', state.slider.id);

        dotIndicator.className = 'dot';
        dot.append(dotIndicator);
        dotsContainer.append(dot);
      });
    }

    dotsContainer.querySelectorAll('[data-collection-carousel-page-dot]').forEach((dot, index) => {
      dot.setAttribute('aria-label', `Näytä sivu ${index + 1} / ${state.totalPages}`);
      dot.classList.toggle('slider-counter__link--active', index === state.currentPage - 1);
      dot.toggleAttribute('aria-current', index === state.currentPage - 1);
    });
  };

  const initCollectionListCarousels = () => {
    document.querySelectorAll('.collection-list-carousel:not([data-carousel-dots-ready])').forEach((carousel) => {
      carousel.dataset.carouselDotsReady = 'true';

      carousel.addEventListener('slideChanged', () => updateCollectionCarouselDots(carousel));

      const slider = carousel.querySelector('[id^="Slider-"]');

      if (slider) {
        slider.addEventListener('scroll', () => updateCollectionCarouselDots(carousel));
      }

      const resizeObserver = new ResizeObserver(() => updateCollectionCarouselDots(carousel));
      resizeObserver.observe(carousel);

      updateCollectionCarouselDots(carousel);
    });
  };

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-collection-carousel-page-dot]');

    if (!dot) return;

    const carousel = dot.closest('.collection-list-carousel');
    const state = getCollectionCarouselState(carousel);

    if (!state) return;

    const targetIndex = state.pageStarts[Number(dot.dataset.collectionCarouselPageDot)] || 0;
    const slide = state.slides[targetIndex];

    state.slider.scrollTo({
      left: slide.offsetLeft - state.slides[0].offsetLeft,
    });
  });

  document.addEventListener('DOMContentLoaded', initCollectionListCarousels);
  document.addEventListener('shopify:section:load', initCollectionListCarousels);
  initCollectionListCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getCarouselState = (carousel) => {
      if (!carousel) return null;

      const slider = carousel.querySelector('[id^="Slider-"]');
      const slides = Array.from(carousel.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);

      if (!slider || !slides.length) return null;

      const itemOffset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;

      if (itemOffset <= 0) return null;

      const visibleStart = slides[0].offsetLeft;
      const visibleEnd = slider.clientWidth - slides[0].offsetLeft;
      const slidesPerPage = Math.max(
        1,
        slides.filter((slide) => slide.offsetLeft >= visibleStart && slide.offsetLeft + slide.clientWidth <= visibleEnd).length
      );
      const maxStartIndex = Math.max(0, slides.length - slidesPerPage);
      const totalPages = Math.max(1, Math.ceil(slides.length / slidesPerPage));
      const pageStarts = Array.from({ length: totalPages }).map((_, index) =>
        Math.min(index * slidesPerPage, maxStartIndex)
      );
      const currentStartIndex = Math.round(slider.scrollLeft / itemOffset);
      const currentPage =
        pageStarts.reduce((closestPage, startIndex, index) => {
          const currentDistance = Math.abs(currentStartIndex - startIndex);
          const closestDistance = Math.abs(currentStartIndex - pageStarts[closestPage]);

          return currentDistance < closestDistance ? index : closestPage;
        }, 0) + 1;

      return {
        slider,
        slides,
        slidesPerPage,
        totalPages,
        pageStarts,
        currentPage,
      };
    };

    const updateDots = (carousel) => {
      const state = getCarouselState(carousel);
      const dotsContainer = carousel.querySelector('[data-featured-collection-carousel-dots]');

      if (!state || !dotsContainer) return;

      if (dotsContainer.children.length !== state.totalPages) {
        dotsContainer.replaceChildren();

        Array.from({ length: state.totalPages }).forEach((_, index) => {
          const dot = document.createElement('button');
          const dotIndicator = document.createElement('span');

          dot.type = 'button';
          dot.className = 'slider-counter__link slider-counter__link--dots link';
          dot.dataset.featuredCollectionCarouselPageDot = index;
          dot.setAttribute('aria-controls', state.slider.id);

          dotIndicator.className = 'dot';
          dot.append(dotIndicator);
          dotsContainer.append(dot);
        });
      }

      dotsContainer.querySelectorAll('[data-featured-collection-carousel-page-dot]').forEach((dot, index) => {
        dot.setAttribute('aria-label', `Näytä sivu ${index + 1} / ${state.totalPages}`);
        dot.classList.toggle('slider-counter__link--active', index === state.currentPage - 1);
        dot.toggleAttribute('aria-current', index === state.currentPage - 1);
      });
    };

    const initCarousels = () => {
      document.querySelectorAll('.featured-collection-carousel:not([data-featured-carousel-dots-ready])').forEach((carousel) => {
        carousel.dataset.featuredCarouselDotsReady = 'true';

        carousel.addEventListener('slideChanged', () => updateDots(carousel));

        const slider = carousel.querySelector('[id^="Slider-"]');

        if (slider) {
          slider.addEventListener('scroll', () => updateDots(carousel));
        }

        const resizeObserver = new ResizeObserver(() => updateDots(carousel));
        resizeObserver.observe(carousel);

        updateDots(carousel);
      });
    };

    document.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-featured-collection-carousel-page-dot]');

      if (!dot) return;

      const carousel = dot.closest('.featured-collection-carousel');
      const state = getCarouselState(carousel);

      if (!state) return;

      const targetIndex = state.pageStarts[Number(dot.dataset.featuredCollectionCarouselPageDot)] || 0;
      const slide = state.slides[targetIndex];

      state.slider.scrollTo({
        left: slide.offsetLeft - state.slides[0].offsetLeft,
      });
    });

    document.addEventListener('DOMContentLoaded', initCarousels);
    document.addEventListener('shopify:section:load', initCarousels);
    initCarousels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class BannerMediaSwitcher {
    constructor(banner) {
      this.banner = banner;
      this.slides = Array.from(banner.querySelectorAll('[data-banner-media-slide]'));
      this.buttons = Array.from(banner.querySelectorAll('[data-banner-media-button]'));
      this.nextButton = banner.querySelector('[data-banner-media-next]');
      this.activeIndex = 0;

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.show(index));
      });

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.show(this.activeIndex + 1));
      }
    }

    show(index) {
      if (!this.slides.length) return;

      this.activeIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.activeIndex);
      });

      this.buttons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === this.activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('[data-banner-media]').forEach((banner) => {
    new BannerMediaSwitcher(banner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    if (window.articleProductsCarouselReady) return;
    window.articleProductsCarouselReady = true;

    const getCarouselState = (carousel) => {
      if (!carousel) return null;

      const slider = carousel.querySelector('[id^="Slider-"]');
      const slides = Array.from(carousel.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);

      if (!slider || !slides.length) return null;

      const itemOffset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;

      if (itemOffset <= 0) return null;

      const visibleStart = slides[0].offsetLeft;
      const visibleEnd = slider.clientWidth - slides[0].offsetLeft;
      const slidesPerPage = Math.max(
        1,
        slides.filter((slide) => slide.offsetLeft >= visibleStart && slide.offsetLeft + slide.clientWidth <= visibleEnd).length
      );
      const maxStartIndex = Math.max(0, slides.length - slidesPerPage);
      const totalPages = Math.max(1, Math.ceil(slides.length / slidesPerPage));
      const pageStarts = Array.from({ length: totalPages }).map((_, index) =>
        Math.min(index * slidesPerPage, maxStartIndex)
      );
      const currentStartIndex = Math.round(slider.scrollLeft / itemOffset);
      const currentPage =
        pageStarts.reduce((closestPage, startIndex, index) => {
          const currentDistance = Math.abs(currentStartIndex - startIndex);
          const closestDistance = Math.abs(currentStartIndex - pageStarts[closestPage]);

          return currentDistance < closestDistance ? index : closestPage;
        }, 0) + 1;

      return {
        slider,
        slides,
        totalPages,
        pageStarts,
        currentPage,
      };
    };

    const updateDots = (carousel) => {
      const state = getCarouselState(carousel);
      const dotsContainer = carousel.querySelector('[data-article-products-carousel-dots]');

      if (!state || !dotsContainer) return;

      if (dotsContainer.children.length !== state.totalPages) {
        dotsContainer.replaceChildren();

        Array.from({ length: state.totalPages }).forEach((_, index) => {
          const dot = document.createElement('button');
          const dotIndicator = document.createElement('span');

          dot.type = 'button';
          dot.className = 'slider-counter__link slider-counter__link--dots link';
          dot.dataset.articleProductsCarouselPageDot = index;
          dot.setAttribute('aria-controls', state.slider.id);

          dotIndicator.className = 'dot';
          dot.append(dotIndicator);
          dotsContainer.append(dot);
        });
      }

      dotsContainer.querySelectorAll('[data-article-products-carousel-page-dot]').forEach((dot, index) => {
        dot.setAttribute('aria-label', `Näytä sivu ${index + 1} / ${state.totalPages}`);
        dot.classList.toggle('slider-counter__link--active', index === state.currentPage - 1);
        dot.toggleAttribute('aria-current', index === state.currentPage - 1);
      });
    };

    const initCarousels = () => {
      document
        .querySelectorAll('.article-products-carousel slider-component:not([data-article-products-carousel-dots-ready])')
        .forEach((carousel) => {
          carousel.dataset.articleProductsCarouselDotsReady = 'true';

          carousel.addEventListener('slideChanged', () => updateDots(carousel));

          const slider = carousel.querySelector('[id^="Slider-"]');

          if (slider) {
            slider.addEventListener('scroll', () => updateDots(carousel));
          }

          const resizeObserver = new ResizeObserver(() => updateDots(carousel));
          resizeObserver.observe(carousel);

          updateDots(carousel);
        });
    };

    document.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-article-products-carousel-page-dot]');

      if (!dot) return;

      const carousel = dot.closest('slider-component');
      const state = getCarouselState(carousel);

      if (!state) return;

      const targetIndex = state.pageStarts[Number(dot.dataset.articleProductsCarouselPageDot)] || 0;
      const slide = state.slides[targetIndex];

      state.slider.scrollTo({
        left: slide.offsetLeft - state.slides[0].offsetLeft,
      });
    });

    document.addEventListener('DOMContentLoaded', initCarousels);
    document.addEventListener('shopify:section:load', initCarousels);
    initCarousels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.collection-hero__description-close');

    if (!closeButton) return;

    const description = closeButton.closest('.collection-hero__description--expandable');

    if (!description) return;

    description.removeAttribute('open');

    const summary = description.querySelector('.collection-hero__description-summary');

    if (summary) {
      summary.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    if (window.relatedProductsCarouselReady) return;
    window.relatedProductsCarouselReady = true;

    const getCarouselState = (carousel) => {
      if (!carousel) return null;

      const slider = carousel.querySelector('[id^="Slider-"]');
      const slides = Array.from(carousel.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);

      if (!slider || !slides.length) return null;

      const itemOffset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;

      if (itemOffset <= 0) return null;

      const visibleStart = slides[0].offsetLeft;
      const visibleEnd = slider.clientWidth - slides[0].offsetLeft;
      const slidesPerPage = Math.max(
        1,
        slides.filter((slide) => slide.offsetLeft >= visibleStart && slide.offsetLeft + slide.clientWidth <= visibleEnd).length
      );
      const maxStartIndex = Math.max(0, slides.length - slidesPerPage);
      const totalPages = Math.max(1, Math.ceil(slides.length / slidesPerPage));
      const pageStarts = Array.from({ length: totalPages }).map((_, index) =>
        Math.min(index * slidesPerPage, maxStartIndex)
      );
      const currentStartIndex = Math.round(slider.scrollLeft / itemOffset);
      const currentPage =
        pageStarts.reduce((closestPage, startIndex, index) => {
          const currentDistance = Math.abs(currentStartIndex - startIndex);
          const closestDistance = Math.abs(currentStartIndex - pageStarts[closestPage]);

          return currentDistance < closestDistance ? index : closestPage;
        }, 0) + 1;

      return {
        slider,
        slides,
        totalPages,
        pageStarts,
        currentPage,
      };
    };

    const updateDots = (carousel) => {
      const state = getCarouselState(carousel);
      const dotsContainer = carousel.querySelector('[data-related-products-carousel-dots]');

      if (!state || !dotsContainer) return;

      if (dotsContainer.children.length !== state.totalPages) {
        dotsContainer.replaceChildren();

        Array.from({ length: state.totalPages }).forEach((_, index) => {
          const dot = document.createElement('button');
          const dotIndicator = document.createElement('span');

          dot.type = 'button';
          dot.className = 'slider-counter__link slider-counter__link--dots link';
          dot.dataset.relatedProductsCarouselPageDot = index;
          dot.setAttribute('aria-controls', state.slider.id);

          dotIndicator.className = 'dot';
          dot.append(dotIndicator);
          dotsContainer.append(dot);
        });
      }

      dotsContainer.querySelectorAll('[data-related-products-carousel-page-dot]').forEach((dot, index) => {
        dot.setAttribute('aria-label', `Näytä sivu ${index + 1} / ${state.totalPages}`);
        dot.classList.toggle('slider-counter__link--active', index === state.currentPage - 1);
        dot.toggleAttribute('aria-current', index === state.currentPage - 1);
      });
    };

    const initCarousels = () => {
      document
        .querySelectorAll('.related-products-carousel:not([data-related-products-carousel-dots-ready])')
        .forEach((carousel) => {
          carousel.dataset.relatedProductsCarouselDotsReady = 'true';

          carousel.addEventListener('slideChanged', () => updateDots(carousel));

          const slider = carousel.querySelector('[id^="Slider-"]');

          if (slider) {
            slider.addEventListener('scroll', () => updateDots(carousel));
          }

          const resizeObserver = new ResizeObserver(() => updateDots(carousel));
          resizeObserver.observe(carousel);

          updateDots(carousel);
        });
    };

    document.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-related-products-carousel-page-dot]');

      if (!dot) return;

      const carousel = dot.closest('.related-products-carousel');
      const state = getCarouselState(carousel);

      if (!state) return;

      const targetIndex = state.pageStarts[Number(dot.dataset.relatedProductsCarouselPageDot)] || 0;
      const slide = state.slides[targetIndex];

      state.slider.scrollTo({
        left: slide.offsetLeft - state.slides[0].offsetLeft,
      });
    });

    const mutationObserver = new MutationObserver(initCarousels);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', initCarousels);
    document.addEventListener('shopify:section:load', initCarousels);
    initCarousels();
  })();

  } catch(e) { console.error(e); }
})();
})();
